// Mock data for Aspen Salon and Spa Website

export const salonInfo = {
  name: "Aspen Salon and Spa",
  brandName: "Aspen Salon and Spa",
  registeredName: "StyleStreetSalon LLP",
  tagline: "Your Destination for Beauty & Wellness",
  phone: "+91 7022683599",
  email: "kalpa18007@gmail.com",
  whatsapp: "+917022683599",
  instagram: "@aspensalonandspa",
  address: {
    street: "No 12, K, 345, Yemalur Main Rd",
    city: "HAL Airport Area, Bellandur, Bengaluru",
    state: "Karnataka",
    zip: "560037"
  },
  googleMapsUrl: "https://maps.app.goo.gl/fShbAac5vqHaQHrw9",
  hours: {
    monday: "10:00 AM - 8:00 PM",
    tuesday: "10:00 AM - 8:00 PM",
    wednesday: "10:00 AM - 8:00 PM",
    thursday: "10:00 AM - 8:00 PM",
    friday: "10:00 AM - 8:00 PM",
    saturday: "10:00 AM - 8:00 PM",
    sunday: "10:00 AM - 8:00 PM"
  }
};

export const services = [
  {
    id: 1,
    category: "Hair Services",
    icon: "Scissors",
    image: "https://images.unsplash.com/photo-1672788725446-c303ec2b318e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjB3b21hbiUyMGJlYXV0eSUyMHNhbG9uJTIwaGFpciUyMHN0eWxpbmd8ZW58MHx8fHwxNzgyMTQ0NjcyfDA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Women's Haircut & Style", duration: "60 min" },
      { name: "Men's Haircut", duration: "45 min" },
      { name: "Blow Dry & Style", duration: "45 min" },
      { name: "Full Color", duration: "120 min" },
      { name: "Partial Highlights", duration: "120 min" },
      { name: "Full Highlights", duration: "150 min" },
      { name: "Balayage", duration: "180 min" },
      { name: "Root Touch-Up", duration: "90 min" },
      { name: "Keratin Treatment", duration: "180 min" },
      { name: "Deep Conditioning Treatment", duration: "30 min" }
    ]
  },
  {
    id: 2,
    category: "Nail Services",
    icon: "Sparkles",
    image: "https://images.pexels.com/photos/8819306/pexels-photo-8819306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    items: [
      { name: "Classic Manicure", duration: "45 min" },
      { name: "Gel Manicure", duration: "60 min" },
      { name: "Luxury Spa Manicure", duration: "75 min" },
      { name: "Classic Pedicure", duration: "60 min" },
      { name: "Gel Pedicure", duration: "75 min" },
      { name: "Luxury Spa Pedicure", duration: "90 min" },
      { name: "Nail Art (per nail)", duration: "15 min" },
      { name: "Acrylic Full Set", duration: "90 min" },
      { name: "Acrylic Fill", duration: "60 min" },
      { name: "Gel Extensions", duration: "120 min" }
    ]
  },
  {
    id: 3,
    category: "Spa & Skincare",
    icon: "Flower2",
    image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB3b21hbiUyMHNwYSUyMGZhY2lhbCUyMHRyZWF0bWVudHxlbnwwfHx8fDE3ODIxNDQ2NzJ8MA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "European Facial", duration: "60 min" },
      { name: "Anti-Aging Facial", duration: "75 min" },
      { name: "Deep Cleansing Facial", duration: "60 min" },
      { name: "Hydrating Facial", duration: "60 min" },
      { name: "Chemical Peel", duration: "45 min" },
      { name: "Microdermabrasion", duration: "60 min" },
      { name: "LED Light Therapy", duration: "30 min" },
      { name: "Back Facial", duration: "60 min" }
    ]
  },
  {
    id: 4,
    category: "Makeup Services",
    icon: "Palette",
    image: "https://images.unsplash.com/photo-1610173826014-d131b02d69ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB3b21hbiUyMG1ha2V1cCUyMGJyaWRhbHxlbnwwfHx8fDE3ODIxNDQ2NzJ8MA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Special Event Makeup", duration: "60 min" },
      { name: "Bridal Makeup", duration: "90 min" },
      { name: "Bridal Trial", duration: "90 min" },
      { name: "Natural Makeup", duration: "45 min" },
      { name: "Makeup Lesson", duration: "60 min" },
      { name: "Airbrush Makeup", duration: "60 min" }
    ]
  },
  {
    id: 5,
    category: "Waxing Services",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1731355771317-b2ab72c79124?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjB3b21hbiUyMHNwYSUyMGZhY2lhbCUyMHRyZWF0bWVudHxlbnwwfHx8fDE3ODIxNDQ2NzJ8MA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Eyebrow Wax", duration: "15 min" },
      { name: "Lip Wax", duration: "10 min" },
      { name: "Full Face Wax", duration: "30 min" },
      { name: "Underarm Wax", duration: "15 min" },
      { name: "Half Leg Wax", duration: "30 min" },
      { name: "Full Leg Wax", duration: "45 min" },
      { name: "Brazilian Wax", duration: "30 min" },
      { name: "Bikini Wax", duration: "20 min" }
    ]
  },
  {
    id: 6,
    category: "Lash & Brow",
    icon: "Eye",
    image: "https://images.unsplash.com/photo-1564141696939-9eb6e957ccfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB3b21hbiUyMGJlYXV0eSUyMHNhbG9uJTIwaGFpciUyMHN0eWxpbmd8ZW58MHx8fHwxNzgyMTQ0NjcyfDA&ixlib=rb-4.1.0&q=85",
    items: [
      { name: "Lash Extensions - Classic", duration: "90 min" },
      { name: "Lash Extensions - Volume", duration: "120 min" },
      { name: "Lash Fill (2-3 weeks)", duration: "60 min" },
      { name: "Lash Lift & Tint", duration: "60 min" },
      { name: "Brow Tinting", duration: "20 min" },
      { name: "Brow Lamination", duration: "45 min" },
      { name: "Microblading", duration: "150 min" },
      { name: "Microblading Touch-Up", duration: "90 min" }
    ]
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Sophia Martinez",
    role: "Master Hair Stylist & Colorist",
    specialties: ["Balayage", "Color Correction", "Bridal Hair"],
    experience: "12 years",
    bio: "Sophia specializes in creating natural, dimensional color and stunning bridal styles. Her expertise in balayage has made her one of our most sought-after colorists.",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop",
    services: ["Hair Services"]
  },
  {
    id: 2,
    name: "Isabella Chen",
    role: "Senior Hair Stylist",
    specialties: ["Precision Cuts", "Keratin Treatments", "Men's Grooming"],
    experience: "10 years",
    bio: "Isabella's precision cutting techniques and attention to detail ensure every client leaves with a style that perfectly suits their lifestyle and features.",
    image: "https://images.unsplash.com/photo-1763906802584-d3bc86db259c?w=400&h=400&fit=crop",
    services: ["Hair Services"]
  },
  {
    id: 3,
    name: "Emma Williams",
    role: "Hair Stylist",
    specialties: ["Highlights", "Blowouts", "Updos"],
    experience: "7 years",
    bio: "Emma is passionate about helping clients discover their perfect style. She excels at creating beautiful highlights and elegant updos for special occasions.",
    image: "https://images.unsplash.com/photo-1615562715183-9528405b75ba?w=400&h=400&fit=crop",
    services: ["Hair Services"]
  },
  {
    id: 4,
    name: "Jasmine Taylor",
    role: "Master Nail Technician",
    specialties: ["Gel Extensions", "Nail Art", "Luxury Spa Treatments"],
    experience: "9 years",
    bio: "Jasmine's artistic approach to nails transforms them into miniature masterpieces. Her gel extension work and intricate nail art designs are truly exceptional.",
    image: "https://images.unsplash.com/photo-1762522929454-ee9a3c765f59?w=400&h=400&fit=crop",
    services: ["Nail Services"]
  },
  {
    id: 5,
    name: "Aisha Johnson",
    role: "Senior Nail Technician",
    specialties: ["Acrylic Nails", "Pedicures", "Natural Nail Care"],
    experience: "8 years",
    bio: "Aisha believes in the importance of nail health alongside beauty. Her gentle techniques and attention to detail make every service a relaxing experience.",
    image: "https://images.unsplash.com/photo-1624045613518-d35d326beecb?w=400&h=400&fit=crop",
    services: ["Nail Services"]
  },
  {
    id: 6,
    name: "Madison Brooks",
    role: "Nail Technician",
    specialties: ["Gel Manicures", "Creative Designs", "Nail Care"],
    experience: "5 years",
    bio: "Madison stays on top of the latest nail trends and loves creating unique designs that express each client's personal style.",
    image: "https://images.unsplash.com/photo-1762522928601-862bf2a04902?w=400&h=400&fit=crop",
    services: ["Nail Services"]
  },
  {
    id: 7,
    name: "Olivia Anderson",
    role: "Licensed Esthetician",
    specialties: ["Anti-Aging Facials", "Chemical Peels", "Skincare Consultation"],
    experience: "11 years",
    bio: "Olivia's deep understanding of skin science allows her to create customized treatment plans that deliver visible results for every skin type.",
    image: "https://images.unsplash.com/photo-1676340619040-8688de9fd331?w=400&h=400&fit=crop",
    services: ["Spa & Skincare"]
  },
  {
    id: 8,
    name: "Lily Rodriguez",
    role: "Esthetician",
    specialties: ["European Facials", "Microdermabrasion", "LED Therapy"],
    experience: "6 years",
    bio: "Lily is passionate about helping clients achieve healthy, glowing skin through personalized facial treatments and professional skincare guidance.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop",
    services: ["Spa & Skincare"]
  },
  {
    id: 9,
    name: "Mia Thompson",
    role: "Makeup Artist",
    specialties: ["Bridal Makeup", "Special Events", "Airbrush"],
    experience: "9 years",
    bio: "Mia's artistry brings out natural beauty while creating stunning looks for life's most important moments. Her bridal makeup is particularly celebrated.",
    image: "https://images.unsplash.com/photo-1615562715183-9528405b75ba?w=400&h=400&fit=crop",
    services: ["Makeup Services"]
  },
  {
    id: 10,
    name: "Ava Martinez",
    role: "Makeup Artist",
    specialties: ["Natural Looks", "Makeup Lessons", "Editorial Makeup"],
    experience: "7 years",
    bio: "Ava loves teaching clients makeup techniques they can recreate at home. Her natural, effortless looks are perfect for everyday beauty.",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop",
    services: ["Makeup Services"]
  },
  {
    id: 11,
    name: "Chloe Davis",
    role: "Lash & Brow Specialist",
    specialties: ["Lash Extensions", "Microblading", "Brow Lamination"],
    experience: "6 years",
    bio: "Chloe's meticulous technique creates beautiful, natural-looking lash extensions and perfectly shaped brows that frame the face.",
    image: "https://images.unsplash.com/photo-1763906802584-d3bc86db259c?w=400&h=400&fit=crop",
    services: ["Lash & Brow"]
  },
  {
    id: 12,
    name: "Grace Wilson",
    role: "Lash & Brow Technician",
    specialties: ["Volume Lashes", "Lash Lifts", "Brow Tinting"],
    experience: "4 years",
    bio: "Grace specializes in volume lash extensions that create dramatic yet wearable looks. Her lash lift treatments are also incredibly popular.",
    image: "https://images.unsplash.com/photo-1762522929454-ee9a3c765f59?w=400&h=400&fit=crop",
    services: ["Lash & Brow"]
  },
  {
    id: 13,
    name: "Harper Garcia",
    role: "Waxing Specialist",
    specialties: ["Full Body Waxing", "Brazilian Wax", "Brow Wax"],
    experience: "8 years",
    bio: "Harper's gentle technique and professionalism make waxing services comfortable and effective. She's known for her attention to detail and client care.",
    image: "https://images.unsplash.com/photo-1624045613518-d35d326beecb?w=400&h=400&fit=crop",
    services: ["Waxing Services"]
  },
  {
    id: 14,
    name: "Ella Brown",
    role: "Waxing Technician",
    specialties: ["Facial Waxing", "Body Waxing", "Sensitive Skin"],
    experience: "5 years",
    bio: "Ella specializes in working with sensitive skin and uses premium, gentle wax formulas to ensure the best results with minimal discomfort.",
    image: "https://images.unsplash.com/photo-1762522928601-862bf2a04902?w=400&h=400&fit=crop",
    services: ["Waxing Services"]
  }
];

export const galleryImages = [
  {
    id: 1,
    category: "Hair",
    image: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxoYWlyJTIwc2Fsb258ZW58MHx8fHwxNzcyNDc2OTM3fDA&ixlib=rb-4.1.0&q=85",
    title: "Balayage Transformation",
    description: "Natural sun-kissed highlights"
  },
  {
    id: 2,
    category: "Hair",
    image: "https://images.unsplash.com/photo-1634449571010-02389ed0f9b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxoYWlyJTIwc2Fsb258ZW58MHx8fHwxNzcyNDc2OTM3fDA&ixlib=rb-4.1.0&q=85",
    title: "Precision Cut",
    description: "Expert styling in action"
  },
  {
    id: 3,
    category: "Makeup",
    image: "https://images.unsplash.com/photo-1758739010986-cbcd556b34ec?w=800&h=800&fit=crop",
    title: "Makeup Artistry",
    description: "Professional makeup application"
  },
  {
    id: 4,
    category: "Hair",
    image: "https://images.unsplash.com/photo-1761931403671-d020a14928d9?w=800&h=800&fit=crop",
    title: "Hair Transformation",
    description: "Expert hair cutting technique"
  },
  {
    id: 5,
    category: "Hair",
    image: "https://images.unsplash.com/photo-1762745103094-6760fab8eb50?w=800&h=800&fit=crop",
    title: "Styling Excellence",
    description: "Beautiful hair transformation result"
  },
  {
    id: 6,
    category: "Makeup",
    image: "https://images.unsplash.com/photo-1619319999528-65275b1356da?w=800&h=800&fit=crop",
    title: "Natural Glow",
    description: "Flawless makeup finish"
  },
  {
    id: 7,
    category: "Nails",
    image: "https://images.unsplash.com/photo-1720343409646-960f6dcccae3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxuYWlsJTIwYXJ0fGVufDB8fHx8MTc3MjQ3Njk0MHww&ixlib=rb-4.1.0&q=85",
    title: "Artistic Nails",
    description: "Custom nail art design"
  },
  {
    id: 8,
    category: "Nails",
    image: "https://images.unsplash.com/photo-1571290274554-6a2eaa771e5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxuYWlsJTIwYXJ0fGVufDB8fHx8MTc3MjQ3Njk0MHww&ixlib=rb-4.1.0&q=85",
    title: "Colorful Designs",
    description: "Vibrant nail artistry"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    service: "Balayage & Styling",
    rating: 5,
    text: "Abhishek completely transformed my hair! The balayage is exactly what I wanted. The team here really listens and the results speak for themselves.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop"
  },
  {
    id: 2,
    name: "Meghna Rao",
    service: "Bridal Makeup",
    rating: 5,
    text: "My wedding makeup was absolutely stunning! They made me feel like a queen on my special day. So many compliments from guests!",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop"
  },
  {
    id: 3,
    name: "Kavitha Reddy",
    service: "Gel Extensions",
    rating: 5,
    text: "The nail art here is incredible! My gel extensions look perfect and last so long. The salon is very clean and the staff is so friendly.",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop"
  },
  {
    id: 4,
    name: "Deepika Nair",
    service: "Anti-Aging Facial",
    rating: 5,
    text: "Best facial experience in Bangalore! My skin feels so refreshed and radiant. They really understand skincare and customize everything.",
    image: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=150&h=150&fit=crop"
  },
  {
    id: 5,
    name: "Ananya Krishnan",
    service: "Lash Extensions",
    rating: 5,
    text: "Alem is amazing with lash extensions! They look so natural and beautiful. I wake up ready to go every day. Highly recommend!",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop"
  },
  {
    id: 6,
    name: "Shreya Hegde",
    service: "Hair Cut & Color",
    rating: 5,
    text: "The best salon experience I've had in Bellandur! They really listened to what I wanted and delivered beyond expectations!",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop"
  }
];

export const specialOffers = [
  {
    id: 1,
    title: "New Client Special",
    description: "20% off your first visit on any service",
    discount: "20% OFF",
    validUntil: "Ongoing",
    terms: "Valid for first-time clients only"
  },
  {
    id: 2,
    title: "Bridal Package",
    description: "Complete bridal beauty package including trial",
    discount: "$100 OFF",
    validUntil: "Limited Time",
    terms: "Includes makeup trial, wedding day makeup, and hair styling"
  },
  {
    id: 3,
    title: "Refer a Friend",
    description: "Give $25, Get $25 when your friend books",
    discount: "$25 OFF",
    validUntil: "Ongoing",
    terms: "Both you and your friend receive $25 off your next service"
  },
  {
    id: 4,
    title: "Monthly Maintenance",
    description: "Book 3 recurring appointments and save 15%",
    discount: "15% OFF",
    validUntil: "Ongoing",
    terms: "Valid on select services. Book in advance to lock in your spot"
  }
];

export const heroImages = [
  "https://images.unsplash.com/photo-1637777277435-3c44f82fd0c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxiZWF1dHklMjBzYWxvbiUyMGludGVyaW9yfGVufDB8fHx8MTc3MjQ3NjgzN3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1746723378067-83a345ff3160?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxiZWF1dHklMjBzYWxvbiUyMGludGVyaW9yfGVufDB8fHx8MTc3MjQ3NjgzN3ww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1626383137804-ff908d2753a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxiZWF1dHklMjBzYWxvbiUyMGludGVyaW9yfGVufDB8fHx8MTc3MjQ3NjgzN3ww&ixlib=rb-4.1.0&q=85"
];
